module.exports = __webpack_public_path__ + "media/images/athletes/2842-7c8b5cda4974e5ca5922b7a4d8937a6a.png";